import type { Firestore } from 'firebase/firestore';
import { db } from '../../firebase/firebase';

/**
 * Single access point for the Firestore instance used by the model layer.
 *
 * Tests can replace the database with one mock instead of stubbing the
 * Firebase bootstrap module:
 *
 *   vi.mock('./base/firestoreDb', () => ({ getDb: () => ({}) }));
 */
export const getDb = (): Firestore => db;
